import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Box,
  TextField,
  Button,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import BuildIcon from "@material-ui/icons/Build";
import { withTranslation } from "react-i18next";
import ApiUser from "../../../../../API/ApiUser";

const CustomCreationDialog = ({ open, onClose, t, userFirstName, userLastName, userEmail }) => {
  const [description, setDescription] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  const handleSubmit = async () => {
    if (!description.trim()) {
      setShowError(true);
      return;
    }

    setIsSubmitting(true);
    setShowError(false);

    try {
      const response = await ApiUser.submitCustomCreationRequest({
        name: `${userFirstName || ""} ${userLastName || ""}`.trim(),
        email: userEmail,
        description,
      });

      if (response.status === 200 || response.status === 201) {
        setShowSuccess(true);
        setDescription("");
        setTimeout(() => {
          setShowSuccess(false);
          onClose();
        }, 2500);
      } else {
        setShowError(true);
      }
    } catch (error) {
      setShowError(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setDescription("");
    setShowError(false);
    setShowSuccess(false);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: "16px",
          backgroundColor: "#F8F9FA",
        },
      }}
    >
      <DialogContent style={{ padding: 0 }}>
        <Box position="relative">
          <IconButton
            onClick={handleClose}
            style={{
              position: "absolute",
              right: 8,
              top: 8,
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              zIndex: 1,
            }}
          >
            <CloseIcon />
          </IconButton>

          <Box p={3}>
            <Box display="flex" alignItems="center" style={{ gap: 10, marginBottom: 8 }}>
              <BuildIcon style={{ color: "#F97316", fontSize: 28 }} />
              <Typography
                variant="h5"
                style={{ fontWeight: 600, color: "#2A3142" }}
              >
                {t("custom_creation_dialog.title")}
              </Typography>
            </Box>

            <Typography
              variant="body1"
              color="textSecondary"
              style={{ marginBottom: 24 }}
            >
              {t("custom_creation_dialog.subtitle")}
            </Typography>

            <TextField
              multiline
              rows={5}
              fullWidth
              inputProps={{ maxLength: 5000 }}
              variant="outlined"
              label={t("custom_creation_dialog.description_label")}
              placeholder={t("custom_creation_dialog.placeholder")}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              style={{ marginBottom: 16 }}
            />

            {showError && (
              <Typography
                variant="body2"
                color="error"
                style={{ marginBottom: 16 }}
              >
                {t("custom_creation_dialog.error")}
              </Typography>
            )}

            {showSuccess && (
              <Typography
                variant="body2"
                style={{ marginBottom: 16, color: "#16A34A" }}
              >
                {t("custom_creation_dialog.success")}
              </Typography>
            )}

            <Button
              variant="contained"
              onClick={handleSubmit}
              disabled={isSubmitting || !description.trim()}
              style={{
                textTransform: "none",
                padding: "10px 24px",
                backgroundColor: "#F97316",
                color: "white",
              }}
            >
              {isSubmitting
                ? t("custom_creation_dialog.submitting")
                : t("custom_creation_dialog.submit")}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default withTranslation()(CustomCreationDialog);
